import questionnaire from './../../../Checkin/questionnaire.js';

export default questionnaire;
